<template>
    <div ref="onfFileInput" class="onf-file-input dropzone" />
</template>

<script>
import Dropzone from 'dropzone';
import Compressor from 'compressorjs'
import 'dropzone/dist/dropzone.css'
Dropzone.autoDiscover = false;
export default {
    name: 'FileInput',
    data: function () {
        return {
            files: [],
            dropZone: null,
            $maxFileSize: 8,
            breakpoints: {
                sm: 0.8,
                md: 0.6,
                lg: 0.3
            }
        }
    },
    watch: {
        files: function () {
            this.$emit('input', this.files);
        }
    },
    props: {
        label: {
            type: String,
            default: 'Anexe Aqui'
        },
        maxFileSize: {
            type: Number,
            default: 8
        },
        maxFilesAllowed: {
            type: Number,
            default: 3
        },
        compress: {
            type: Boolean,
            default: false
        },
        compressFactorBreakpoints: {
            type: Array,
            default () {
                return [0, 1]
            }
        }
    },
    methods: {
        construct: function () {
            this.setDropZone();
            this.setParams();
        },
        setParams: function () {
            this.$maxFileSize = this.maxFileSize;
        },
        setDropZone: function () {
            if(this.$refs.onfFileInput) {
                const self = this;
                this.dropZone = new Dropzone(this.$refs.onfFileInput, {
                    addRemoveLinks: true,
                    acceptedFiles: '.png,.jpeg,.jpg',
                    dictDefaultMessage: this.label,
                    dictCancelUpload: 'Cancelar Upload',
                    autoProcessQueue: false,
                    dictRemoveFile: 'Remover',
                    dictMaxFilesExceeded: 'Maximo de 3 imagens',
                    url: '#',
                    init: function () {
                        this.on('addedfile', file => {
                            self.addFile(file);
                            self.syncFiles();
                        });
                        this.on('removedfile', file => {
                            self.removeFile(file);
                            self.syncFiles();
                        });
                    }
                });
            }
        },
        receiveFile (file) {
            this.dropZone.addFile(file);
        },
        fillThumbnail () {
            const missingThumbnailsTypes = { 'application/pdf': true };
            setTimeout(() => {
                this.files.forEach(file => {
                    if (missingThumbnailsTypes[file.type] === true || this.compress) {
                        if (file.type === 'application/pdf') {
                            this.fillThumbnailPdf(file)
                            return;
                        }
                        this.fillThumbnailImage(file);
                    }
                })
            }, 500)
        },
        fillThumbnailImage (file) {
            const imageContainer = file.previewElement.querySelector('.dz-image')
            const img = imageContainer.querySelector('img');
            img.style.width = '100%'
            img.style.height = '100%'
            img.src = (window.URL || window.webkitURL || window || {}).createObjectURL(file);
        },
        fillThumbnailPdf (file) {
            const url = (window.URL || window.webkitURL || window || {}).createObjectURL(file);
            this.oFile(url).createPdfThumbnail().then(base64 => {
                file.previewElement.querySelector('.dz-image img').src = base64;
            })
        },
        addFile (file) {
            this.compressFile(file, this.dropZone).then(compressor => {
                this.validateSize(compressor.compressedFile);
                this.validateAmount(this.dropZone);
                this.fillThumbnail();
                this.$emit('fileConfirmed');
            }).catch(e => {
                this.dropZone.removeFile(file);
            })
        },
        removeFile(file){
            let index = this.dropZone.files.findIndex((fileObj) => {
                return fileObj.name === file.name;
            });
            this.files = this.dropZone.files.splice(index, 1);
            this.$emit('fileRemoved');
        },
        async compressFile (file, dropZone) {
            return new Promise(resolve => {
                if (file.type.split('/')[0] === 'image' && this.compress) {
                    const compressedFileManager = new Compressor(file, {
                        quality: this.getCompressQuality(file),
                        success: resultFile => {
                            const compressedFile = new File([resultFile], resultFile.name, { type: resultFile.type });
                            Object.keys(file).forEach(fileKey => {
                                compressedFile[fileKey] = file[fileKey]
                            });
                            compressedFile.upload.total = compressedFile.size;
                            dropZone.files.forEach((oldFile, index) => {
                                if (oldFile.name === compressedFile.name) {
                                    dropZone.files[index] = compressedFile;
                                    this.files[index] = compressedFile;
                                }
                            });

                            resolve({ compressedFileManager, compressedFile })
                        }
                    });

                    return;
                }

                resolve({ compressedFileManager: null, compressedFile: file })
            })
        },
        getCompressQuality (file) {
            const fileSize = file.size / 1000000;
            if (fileSize <= this.compressFactorBreakpoints[0]) {
                return this.breakpoints.sm;
            }

            if (fileSize > this.compressFactorBreakpoints.reverse()[0]) {
                return this.breakpoints.lg;
            }

            return this.breakpoints.md;
        },
        validateSize: function (file) {
            if (file.size > (this.$maxFileSize * 1000000)) {
                this.$swal.generalTimedAlert({ icon: 'error', title: 'Limite Excedido', text: 'Tamanho máximo do arquivo de 8mb!', timer: 3000 });
                throw new Error('Tamanho máximo do arquivo de 8mb!');
            }
        },
        validateAmount: function (dropZone) {
            if (dropZone.files.length > this.maxFilesAllowed) {
                this.$swal.generalTimedAlert({ icon: 'error', title: 'Limite Excedido', text: 'Maximo de 3 arquivos!', timer: 3000 });
                throw new Error('Maximo de 3 arquivos!');
            }
        },
        syncFiles: function () {
            const files = [];
            Object.values(this.dropZone.files).forEach(file => {
                files.push(file);
            });
            this.files = files;
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.construct();
        })
    }
}
</script>

<style>
    .dropzone {
        border-radius: 8px;
        border-width: 1px;
        border-style: dashed;
    }
    .dz-progress{
        display: none;
    }
</style>
